(() => {
  const root = document.querySelector('.dcom-textile-page .prd-block-info');
  if (!root) return;

  const summaryTiers = new Set([2, 5, 10, 50, 100]);
  const syncRows = () => {
    root.querySelectorAll('.dcd-volume-wrap .hulkapps-table tbody > tr').forEach(row => {
      const quantity = row.cells[0]?.textContent.trim().match(/^\d+/);
      if (!quantity) return;
      const tier = summaryTiers.has(Number(quantity[0])) ? 'summary' : 'detail';
      if (row.dataset.dcomTier !== tier) row.dataset.dcomTier = tier;
      const priceCell = row.cells[1];
      if (!priceCell) return;
      const badge = priceCell.querySelector('.hulkapps-price + span');
      if (badge && !badge.hasAttribute('data-dcom-popular')) badge.setAttribute('data-dcom-popular', '');
    });
  };

  let scheduled = false;
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      syncRows();
    });
  };

  syncRows();
  // Hulk injects and refreshes its table when the product variant changes.
  new MutationObserver(scheduleSync).observe(root, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
